import React, { useState } from "react";

function ReconnectingLoader({ text }) {

    return (
        <>
            <div className="">
                <div
                    className="position-fixed w-100 mainLoader"
                    style={{
                        zIndex: 1100000000000,
                        // marginTop: -200,
                        height: '100%',
                        marginLeft: 0,
                        background: "var(--loader-bg)",
                        backdropFilter: "blur(20px)",
                        top: '0px',
                        left: '0px'
                    }}
                >
                    <div className="h-100 d-flex align-items-center justify-content-center">
                        <div className="d-flex flex-wrap align-items-center justify-content-center" style={{ flexDirection: 'column' }}>
                            <p
                                className="text-center loader-text"
                            >
                                {text.heading}

                            </p>
                            {text.paragraph && <p className="text-center loader-text-para">{text.paragraph}</p>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ReconnectingLoader;